import _slicedToArray from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { SearchkitComponent, ViewOptionsAccessor, RenderComponentPropType, renderComponent } from "../../../core";
import { Toggle } from "../../ui";

var defaults = require("lodash/defaults");

export var ViewSwitcherToggle =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(ViewSwitcherToggle, _SearchkitComponent);

  function ViewSwitcherToggle() {
    _classCallCheck(this, ViewSwitcherToggle);

    return _possibleConstructorReturn(this, _getPrototypeOf(ViewSwitcherToggle).apply(this, arguments));
  }

  _createClass(ViewSwitcherToggle, [{
    key: "getViewOptionsSwitcherAccessor",
    value: function getViewOptionsSwitcherAccessor() {
      return this.searchkit.getAccessorByType(ViewOptionsAccessor);
    }
  }, {
    key: "setView",
    value: function setView(view) {
      this.getViewOptionsSwitcherAccessor().setView(view);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var viewOptionsAccessor = this.getViewOptionsSwitcherAccessor();

      if (viewOptionsAccessor) {
        var options = viewOptionsAccessor.options;
        var selectedOption = viewOptionsAccessor.getSelectedOption().key;
        return renderComponent(this.props.listComponent, {
          mod: this.props.mod,
          className: this.props.className,
          disabled: !this.hasHits(),
          items: options,
          selectedItems: [selectedOption],
          toggleItem: this.setView.bind(this),
          setItems: function setItems(_ref) {
            var _ref2 = _slicedToArray(_ref, 1),
                item = _ref2[0];

            return _this.setView(item);
          },
          translate: this.translate
        });
      }

      return null;
    }
  }]);

  return ViewSwitcherToggle;
}(SearchkitComponent);
ViewSwitcherToggle.defaultProps = {
  listComponent: Toggle
};
ViewSwitcherToggle.propTypes = defaults({
  listComponent: RenderComponentPropType
}, SearchkitComponent.propTypes);